import { setThemingIsEnabled } from '@1js/acui-theme/lib/ThemingExperiment';
import type { AppColors } from '@1js/acui-common/lib/utilities/appColors';
import { getPalette } from 'owa-theme';
import { computed } from 'mobx';

let appThemeInitialized = false;
export function ensureAppThemeInitialized() {
    if (!appThemeInitialized) {
        setThemingIsEnabled(true);
        appThemeInitialized = true;
    }
}

const createAppColors = computed(
    (): AppColors => {
        const palette = getPalette();
        return {
            shade30: palette.themeDarker!,
            shade20: palette.themeDark!,
            shade10: palette.themeDarkAlt!,
            primary: palette.themePrimary!,
            tint10: palette.themeSecondary!,
            tint20: palette.themeTertiary!,
            tint30: palette.themeLight!,
            tint40: palette.themeLighter!,
        };
    }
);

export function getAppColors(): AppColors {
    return createAppColors.get();
}
